var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrops(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Water") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M26.723.712a1.489 1.489 0 0 1 .65-.575 1.49 1.49 0 0 1 1.887.548 1.51 1.51 0 0 1 0 1.63c-.429.662-.849 1.316-1.26 1.964-.411-.648-.831-1.302-1.26-1.964A1.5 1.5 0 1 1 29.278.712C40.415 17.93 46 30.458 46 38.5 46 48.088 37.747 56 28 56s-18-7.912-18-17.5c0-8.042 5.585-20.57 16.723-37.788zM13 38.5C13 46.402 19.883 53 28 53s15-6.598 15-14.5c0-7-4.99-18.467-15-34.221C17.99 20.033 13 31.5 13 38.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    fillRule: "nonzero",
    d: "M17 37.5a1.5 1.5 0 0 1 3 0c0 4.633 3.911 8.5 8.5 8.5a1.5 1.5 0 0 1 0 3C22.262 49 17 43.798 17 37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h56v56H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrops);
export default __webpack_public_path__ + "static/media/drops.4d8b19751cd06c3aa750ce880e5eb4d6.svg";
export { ForwardRef as ReactComponent };